import React, { useState } from 'react';

interface FileInfoTooltipProps {
  completeName: string;
  className?: string;
}

export const FileInfoTooltip: React.FC<FileInfoTooltipProps> = ({ completeName, className = '' }) => {
  const [show, setShow] = useState(false);

  const cleanName = completeName?.trim();
  if (!cleanName) return null;

  return (
    <div
      className={`relative inline-flex items-center group/info ${className}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        title={cleanName}
        aria-label={`Complete File Name: ${cleanName}`}
        className="p-1 rounded-md text-gray-400 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-950/50 transition-colors cursor-help flex items-center justify-center flex-shrink-0"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Floating Hover Tooltip */}
      {show && (
        <div className="pointer-events-none absolute bottom-full right-0 mb-1.5 z-50 flex flex-col items-end w-max max-w-[280px] sm:max-w-xs md:max-w-sm drop-shadow-xl animate-in fade-in zoom-in-95 duration-100">
          <div className="bg-gray-900 text-white dark:bg-gray-800 text-xs rounded-xl px-3 py-2 shadow-2xl border border-gray-700 dark:border-gray-600 leading-snug break-words">
            <div className="text-[10px] uppercase font-bold tracking-wider text-blue-400 mb-0.5 flex items-center gap-1">
              <span>ℹ️</span> Complete File Name
            </div>
            <div className="font-semibold text-gray-100 text-[11px] select-all">
              {cleanName}
            </div>
          </div>
          {/* Tooltip caret */}
          <div className="w-2 h-2 bg-gray-900 dark:bg-gray-800 rotate-45 mr-2.5 -mt-1 border-r border-b border-gray-700 dark:border-gray-600"></div>
        </div>
      )}
    </div>
  );
};
